import { inject, Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';
import { FuncService } from '../../../services';
import { FinanceAreaService } from '../finance-area.service';

/**
 * The list of tabs on this page
 */
export enum FinanceCostPageTabId {
	Cost = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum FinanceCostPageViewId {
	Trimester = 1,
}


@Injectable({ providedIn: 'root' })
export class FinanceCostPageService extends PageTabsLayoutPageService<FinanceCostPageTabId, FinanceCostPageViewId> {

	private readonly func = inject(FuncService);
	private readonly areaService = inject(FinanceAreaService);
	// public readonly acceleratorEnrollments = computed(() => this.areaService.experienceData()?.acceleratorEnrollments || []);

	private static readonly _viewDroplistItems: DroplistItem<never, FinanceCostPageViewId>[] = [
		{
			uniqueId: FinanceCostPageViewId.Trimester, iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'By Trimester',
				hideText: 'never',
			},
			customSort: '1'
		},
	];
	constructor() {
		super(FinanceCostPageService._viewDroplistItems, FinanceCostPageService.name, FinanceCostPageTabId.Cost, FinanceCostPageViewId.Trimester);
	}

	public get viewId() {
		return FinanceCostPageViewId;
	}

	// public async getAllCourses() {
	// 	const courses = await this.func.course.getAllCourses();
	// 	this.courses.set(courses);
	// }

	public async reloadData() {
		// await this.getAllCourses();
	}

}